export default "/images/ic-template-a.svg?1240b145981ac9c66eb9b3407e9cb4c7";